import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { OffboardingAssignment, OffboardingCase, OffboardingReplacement } from '../../models/offboarding.model';
import { workflowTrackBy } from '../common/employee-assets/asset.helpers';

const REPLACEMENT = {role: 'ROLE', empty: '', first: 0};
interface ReplacementRow {key: string; obligation: OffboardingReplacement; pair: OffboardingAssignment;}
@Component({selector: 'app-offboarding-replacements', templateUrl: './offboarding-replacements.component.html',
  styleUrls: ['./offboarding-sequential.component.css', './offboarding-workspace-content.css']})
export class OffboardingReplacementsComponent implements OnChanges {
  @Input() item: OffboardingCase;
  @Input() disabled = false;
  @Output() refresh = new EventEmitter<void>();
  trackBy = workflowTrackBy;
  rows: ReplacementRow[] = [];
  editing: ReplacementRow;
  ngOnChanges(): void {
    const editingKey = this.editing ? this.editing.key : REPLACEMENT.empty;
    this.rows = (this.item.replacementObligations || []).map(value => ({key: value.assignmentId || value.departmentId,
      obligation: value, pair: {id: value.assignmentId, version: value.currentVersion, function: value.function,
        locationCode: value.locationCode, assigneeId: value.currentAssigneeId || REPLACEMENT.empty,
        assigneeName: value.currentAssigneeName, substituteId: value.currentSubstituteId,
        substituteName: value.currentSubstituteName, active: true}}));
    this.editing = this.rows.filter(row => row.key === editingKey)[REPLACEMENT.first];
  }
  edit(row: ReplacementRow): void { this.editing = row; }
  saved(): void { this.editing = null; this.refresh.emit(); }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-replacements.component.ts